import React from "react";
import { Button } from "antd";
import { CheckCircleFilled, MailOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import "./auth.css";

const OrganizationRegistrationSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { org, email } = location.state || {};

  return (
    <div className="ciq-auth">
      <aside className="ciq-auth__brand">
        <div className="ciq-auth__brand-bg" />
        <div className="ciq-auth__brand-inner">
          <a className="ciq-brand" href="https://coreiqpro.com">
            <img src={`${process.env.PUBLIC_URL}/logo-icon.png`} alt="CoreIQPro" />
            <span className="ciq-brand__txt">
              Core<span className="o">IQ</span>Pro
            </span>
          </a>
          <h1 className="ciq-auth__headline">Your workspace is ready to activate.</h1>
          <p className="ciq-auth__sub">
            {org ? `${org} has been registered on CoreIQPro. ` : "Your organization has been registered on CoreIQPro. "}
            One quick email step for your administrator and your team can get started.
          </p>
          <ul className="ciq-auth__points">
            <li>
              <i className="fas fa-check" /> Invite your team and assign roles
            </li>
            <li>
              <i className="fas fa-check" /> Build learning paths and training programs
            </li>
            <li>
              <i className="fas fa-check" /> Track progress across your whole organization
            </li>
          </ul>
        </div>
      </aside>

      <main className="ciq-auth__panel">
        <div className="ciq-auth__card">
          <div className="ciq-auth__card-head">
            <div>
              <h2>Organization registered</h2>
              <p className="ciq-auth__muted">Your organization account has been created.</p>
            </div>
          </div>

          <div className="ciq-auth__msg success">
            <div className="ciq-auth__msg-title">
              <CheckCircleFilled /> Check the administrator&apos;s email
            </div>
            We have sent an activation link to your Tenant Administrator
            {email ? (
              <>
                {" "}
                at <strong>{email}</strong>.
              </>
            ) : (
              "."
            )}
          </div>

          <div className="ciq-auth__steps">
            <div className="ciq-auth__step">
              <span className="n">1</span> The Tenant Administrator opens the activation email
            </div>
            <div className="ciq-auth__step">
              <span className="n">2</span> They click the link and set the admin password
            </div>
            <div className="ciq-auth__step">
              <span className="n">3</span> Sign in as admin and start inviting your team
            </div>
          </div>

          <p className="ciq-auth__tip">
            <MailOutlined /> Tip: check the spam folder if the email does not arrive. The link is valid for 24 hours.
          </p>

          <Button type="primary" block onClick={() => navigate("/login")}>
            Go to Sign In
          </Button>
        </div>
      </main>
    </div>
  );
};

export default OrganizationRegistrationSuccess;
